import axios from 'axios';

// Use environment variable or fallback to HuggingFace backend
const API_URL = process.env.REACT_APP_API_URL || 'https://SaiPrasad12321-insititue.hf.space/api';

// Create axios instance
const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add token to requests
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Auth API
export const authAPI = {
    login: (email, password) => api.post('/auth/login', { email, password }),
    getMe: () => api.get('/auth/me'),
    registerStudent: (studentData) => api.post('/auth/register-student', studentData),
};

// Admin API
export const adminAPI = {
    getStudents: () => api.get('/admin/students'),
    createProject: (projectData) => api.post('/admin/projects', projectData),
    updateProject: (id, projectData) => api.put(`/admin/projects/${id}`, projectData),
    uploadDocumentation: (id, formData) =>
        api.post(`/admin/projects/${id}/documentation`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),
    getSubmissions: () => api.get('/admin/submissions'),
    reviewSubmission: (id, status, reviewNotes) =>
        api.put(`/admin/submissions/${id}/review`, { status, reviewNotes }),
    uploadCertificate: (studentId, projectId, formData) =>
        api.post(`/admin/certificates/${studentId}/${projectId}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),
};

// Student API
export const studentAPI = {
    getProjects: () => api.get('/student/projects'),
    getProjectDetails: (id) => api.get(`/student/projects/${id}`),
    submitProject: (projectId, githubLink) =>
        api.post('/student/submit', { projectId, githubLink }),
    getTest: (projectId) => api.get(`/student/test/${projectId}`),
    submitTest: (projectId, answers) => api.post(`/student/test/${projectId}`, { answers }),
    downloadCertificate: (projectId) =>
        api.get(`/student/certificate/${projectId}`, { responseType: 'blob' }),
    getStepProgress: (projectId) => api.get(`/student/projects/${projectId}/progress`),
    completeStep: (projectId, stepNumber) =>
        api.post(`/student/projects/${projectId}/steps/${stepNumber}/complete`),
};

// Projects API
export const projectsAPI = {
    getProjects: (category, type) => {
        const params = {};
        if (category) params.category = category;
        if (type) params.type = type;
        return api.get('/projects', { params });
    },
    getProjectById: (id) => api.get(`/projects/${id}`),
};

export default api;
